export default __webpack_public_path__ + "images/bd8c48baf2fa3d34cdde7b859e350c10-plus-circle.svg";